(() => {
  if (window.joannaCopyModeReady) return;
  window.joannaCopyModeReady = true;
  const buttons = document.querySelectorAll('[data-jc-mode]');
  if (!buttons.length) return;
  const setMode = dark => {
    document.documentElement.dataset.joannaCopyMode = dark ? 'dark' : 'light';
    buttons.forEach(button => {
      button.setAttribute('aria-pressed', String(dark));
      button.setAttribute('aria-label', dark ? button.dataset.lightLabel : button.dataset.darkLabel);
    });
  };
  let saved = 'light';
  try { saved = localStorage.getItem('joanna-copy-mode'); } catch {}
  setMode(saved === 'dark');
  buttons.forEach(button => button.addEventListener('click', () => {
    const dark = document.documentElement.dataset.joannaCopyMode !== 'dark';
    setMode(dark);
    try { localStorage.setItem('joanna-copy-mode', dark ? 'dark' : 'light'); } catch {}
  }));
})();
